module.exports = __webpack_public_path__ + "media/images/front/dummy/img_upload-437bf3c33a3553d5b3c90d049e50396c.png";